import { Fragment } from "react";
import { Link } from "react-router-dom";
import henceforthApi from "../../utils/henceforthApi";
import profile_placeholder from '../../assets/images/pages/profile_placeholder.png'
import { numberWithCommas } from "../../utils/validations";
import COPY from "../../../src/assets/images/copy.png"
import copy from "copy-to-clipboard";

export default (res: any) => <tr>
    <td>{Number(res.page) == 0
        ? res.index + 1
        : (Number(res.page) - 1) * res.limit + (res.index + 1)}</td>
    <td>{res.order_id} <img src={COPY} style={{ width: 15 }} onClick={() => res.copyText(res.order_id, "Order Id")} role="button" data-toggle="tooltip" title={res.order_id} /></td>
    <td className='product-image-table'>
        <Link to={`/user/${res?.customer_detail?._id}`}>
            <Fragment>
                <img src={res?.customer_detail?.profile_pic ? `${henceforthApi.API_FILE_ROOT_ORIGINAL}${res?.customer_detail?.profile_pic}` : profile_placeholder} alt="img" className='rounded-circle me-2' />
                <span>{res.customer_detail?.name ? res.customer_detail?.name : "Not Avaiable"}</span>
            </Fragment>
        </Link>
    </td>
    {/* <td><b>&#8377;</b>{res.total_price.toLocaleString()}</td> */}
    <td><b>&#36;{numberWithCommas(res.total_price)}</b></td>
    <td><b>&#36;{numberWithCommas(res?.admin_earning || 0)}</b></td>
    <td> <div className="btn-group gap-2">
        <Link className="btn btn-white btn-sm" to={`/ordersdetails/${res._id}`}> <i className="fa fa-eye me-1"></i>View</Link>
    </div></td>

</tr>